class BESSAppAuthAPIService extends BESSAppAPIServiceBase {

    constructor(parent) {
        super(parent, 'auth/');
    }

    loginUser(email, password, onSuccess, onFailure) {
        this._post('login', {
            data: {
                'email': email, 'password': password,
            }, onResult: function (result) {
                if (result.authenticated) {
                    onSuccess();
                } else {
                    onFailure();
                }
            },
        })
    }

    forgottenPassword(email) {
        this._post('forgotten-password', {
            data: {
                'email': email,
            }, onResult: null,
        });
    }


    updatePassword(currentPassword, password, onSuccess, onFailure) {
        this._post('update-password', {
            data: {
                'current_password': currentPassword,
                'password': password
            }, onResult: function (result) {
                if (result.updated) {
                    onSuccess();
                } else {
                    onFailure(result.reason);
                }
            }
        })
    }

    registerUser(email, name, organisation, password, receiveEmailUpdates, role, token, onSuccess, onFailure) {
        this._post('register', {
            data: {
                'email': email,
                'name': name,
                'organisation': organisation,
                'password': password,
                'receive_email_updates': receiveEmailUpdates,
                'role': role,
                'token': token,
                //'industry': industry,
            },
            onResult: function (result) {
                if (result.registered) {
                    onSuccess();
                } else {
                    onFailure(result.reason);
                }
            }
        })
    }

    updateUser(email, name, organisation, role, industry, onSuccess) {
        this._post('update', {
            data: {
                'email': email,
                'name': name,
                'organisation': organisation,
                'role': role,
                'industry': industry,
            },
            onResult: function (result) {
                if (result.updated) {
                    onSuccess();
                }
            }
        })
    }

    updateUserEmailPreference(receiveEmailUpdates, receiveEmailSubmissionUpdates) {
        this._post('update-email-preference', {
            data: {
                'receive_email_updates': receiveEmailUpdates,
                'receive_email_submission_updates': receiveEmailSubmissionUpdates,
            },
        })
    }


    updateUserTrainingPreference(trainedProfessionalShow) {
        this._post('update-training-preference', {
            data: {
                'trained_professional_show': trainedProfessionalShow,
            },
        })
    }
}